
import { Component, Prop } from '@modules/vue-property-decorator/lib';
import { CheckoutPaymentData } from './checkoutPayment.vue';
import Vue from 'vue';
import CircleIcon from '@shared/components/container/circleIcon.vue';
import Container from '@shared/components/container/container.vue';
import { SaleItem } from '@shared/core/interfaces/saleItem';
import { ShopService } from '@shared/core/services/shopService';
import { CrudService } from '@shared/core/services/crudService';
import { Format } from '@shared/core/helpers/formatHelper';
import { Settings } from '@shared/core/services/configService';
import store from "@shared/core/store";

@Component({
  components: {
    Container,
    CircleIcon,
  },
})
export default class CheckoutPayWithVouchers extends Vue {
  @Prop({ required: true }) private data!: CheckoutPaymentData;
  @Prop({ required: true }) private cid!: any;
  @Prop({ default: false }) private acceptConditions!: boolean;
  @Prop({ default: false }) private okRss!: boolean;

  private readonly Format = Format;
  private readonly shopService: ShopService;
  private readonly crudService: CrudService;
  private selectedVoucher: Record<number, number> = {}; // saleId - voucherId
  private error: string = "";

  constructor() {
    super();
    this.shopService = new ShopService();
    this.crudService = new CrudService();
  }

  private get isDarkMode() {
    return store.state.settings.DarkMode === true;
  }

  private get voucherSaleItems() {
    return this.$store.state.cart.sItems.filter(s => s.saleId && this.vouchersBySaleId[s.saleId]?.length);
  }

  private get voucherSales() {
    return this.$store.state.cart.sales.filter(s => s.id && this.vouchersBySaleId[s.id]?.length);
  }

  private get vouchersBySaleId() {
    return this.data.vouchers.reduce((map: Record<number, any[]>, voucher: any) => {
      let list = map[voucher.saleId];
      if (list) {
        list.push(...voucher.vouchers);
      } else {
        map[voucher.saleId] = [...voucher.vouchers];
      }
      return map;
    }, {});
  }

  async payVoucher(sale: any, saleItem: any, saleId: number) {
    this.error = "";
    // this.cleanErrors();
    // this.checkErrors(true);

    if (!Format.IsNull(this.error)) {
      this.$store.commit("openGlobalError", this.error);
      return;
    }

    if (sale && this.data.allowVouchers.allowed === false) {
      const error = this.data.allowVouchers.reason;
      this.$store.commit("openGlobalError", error);
      return;
    }
    
    if (!this.selectedVoucher[saleId]) {
      return;
    }
    const vouchers = this.vouchersBySaleId[saleId];
    let paymentMethodId = -1;
    const voucherId = this.selectedVoucher[saleId];
    for (const v of vouchers) {
      if (v.voucher.id == voucherId) {
        paymentMethodId = v.id;
      }
    }

    let url = `${Settings.HostName}/api/shop/checkout-customer`;

    const data = await this.crudService.httpPost(url, {
      saleIds: sale ? [sale.id] : null,
      saleItems: saleItem ? [saleItem] : null,
      paymentMethodId: paymentMethodId,
      voucherId: voucherId,
      customer: {
        id: this.cid,
        okRss: this.okRss,
        acceptConditions: this.acceptConditions,
      },
    });

    const errorMsg = this.$t(
      "Ups! Tecnical problems. Please try again in a few minutes"
    ).toString();

    if (data == null || data === undefined) {
      console.error("Crash checkout " + this.cid);
      this.error = errorMsg;
      return;
    }

    if (data.ok === false || data.errors !== undefined) {
      this.error = data.model.errorMsg !== "" ? data.model.errorMsg : errorMsg;
      return;
    }

    if (saleItem !== null && saleItem !== undefined) {
      this.shopService.removeSaleItemFromCart(saleItem);
    }

    if (saleId > 0) {
      this.shopService.removeSaleFromCart(saleId, false);
    }

    if (!Format.IsNull(data.model) && !Format.IsNull(data.model.saleNumber)) {
      // partial payment with money voucher, reload sale bc it is not fully paid
      this.shopService.addSaleToCart(data.model, null);
      this.$router.go(0);
      return;
    }

    if (this.$store.state.cart.count === 0) {
      return this.$router.push("/cz/ok");
    }
  }

  private getImagePath(img?: string | null) {
    if (!img) {
      return this.$store.state.settings.Uploads + "/" + this.$store.state.settings.Mainlogo;
    }
    return this.$store.state.settings.Uploads + "/" + img;
  }
  private removeSaleItemFromCart(sItem: SaleItem) {
    this.shopService.removeSaleItemFromCart(sItem);
  }
  private removeSaleFromCart(saleId: number) {
    this.shopService.removeSaleFromCart(saleId);
  }
}
